// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__fj9y+","footer__links":"Footer_footer__links__tY0Ia","footer__link":"Footer_footer__link__MSmI4","footer__linksItem":"Footer_footer__linksItem__tw+sc"};